export const ENTRY_STATUS = {
  submitted: { label: 'Iesniegts', className: 'bg-blue-100 text-blue-700' },
  needs_fix: { label: 'Jālabo', className: 'bg-amber-100 text-amber-700' },
  approved: { label: 'Apstiprināts', className: 'bg-green-100 text-green-700' },
  closed: { label: 'Slēgts', className: 'bg-gray-200 text-gray-700' }
};

export const TASK_STATUS = {
  assigned: { label: 'Piešķirts', className: 'bg-blue-100 text-blue-700' },
  in_progress: { label: 'Procesā', className: 'bg-amber-100 text-amber-700' },
  submitted: { label: 'Iesniegts', className: 'bg-indigo-100 text-indigo-700' },
  completed: { label: 'Pabeigts', className: 'bg-green-100 text-green-700' }
};

export const PROJECT_STATUS_ORDER = ['not_started', 'in_progress', 'completed', 'verified', 'delivered', 'closed'];

export const PROJECT_STATUS = {
  not_started: { label: 'Nav sākts', i18nKey: 'portalUi.status.notStarted', className: 'bg-gray-100 text-gray-700', text: 'text-gray-600', border: 'border-gray-200' },
  in_progress: { label: 'Procesā', i18nKey: 'portalUi.status.inProgress', className: 'bg-amber-100 text-amber-700', text: 'text-amber-600', border: 'border-amber-200' },
  completed: { label: 'Pabeigts', i18nKey: 'portalUi.status.completed', className: 'bg-green-100 text-green-700', text: 'text-green-600', border: 'border-green-200' },
  verified: { label: 'Pārbaudīts', i18nKey: 'portalUi.status.verified', className: 'bg-teal-100 text-teal-700', text: 'text-teal-600', border: 'border-teal-200' },
  delivered: { label: 'Nodots klientam', i18nKey: 'portalUi.status.delivered', className: 'bg-blue-100 text-blue-700', text: 'text-blue-600', border: 'border-blue-200' },
  closed: { label: 'Slēgts', i18nKey: 'portalUi.status.closed', className: 'bg-slate-200 text-slate-700', text: 'text-slate-600', border: 'border-slate-300' },
  on_hold: { label: 'Pauzēts', i18nKey: 'portalUi.status.onHold', className: 'bg-orange-100 text-orange-700', text: 'text-orange-600', border: 'border-orange-200' }
};
PROJECT_STATUS.active = PROJECT_STATUS.in_progress;

export const projectStatus = (status) => PROJECT_STATUS[status] || PROJECT_STATUS.not_started;

export const projectStatusLabel = (t, status) => {
  const config = projectStatus(status);
  return t ? t(config.i18nKey, config.label) : config.label;
};

export const PROJECT_DONE_STATUSES = ['completed', 'verified', 'delivered', 'closed'];

export const SALARY_STATUS = {
  open: { label: 'Sagatave', className: 'bg-amber-100 text-amber-800' },
  verified: { label: 'Pārbaudīts', className: 'bg-teal-100 text-teal-800' },
  paid: { label: 'Izmaksāts', className: 'bg-green-100 text-green-800' }
};

export const RATE_SOURCE_LABELS = { task: 'uzdevuma likme', employee: 'individuālā likme', standard: 'standarta likme' };

export const COST_TYPES = [
  { value: 'transport', label: 'Transports' },
  { value: 'fuel', label: 'Degviela' },
  { value: 'paint', label: 'Krāsa (baloni)' },
  { value: 'other', label: 'Citas izmaksas' }
];

export const toDateInput = (value) => (value ? new Date(value).toISOString().split('T')[0] : '');

export const ADJUSTMENT_TYPES = [
  { value: 'piemaksa', label: 'Piemaksa' },
  { value: 'premija', label: 'Prēmija' },
  { value: 'atvalinajums', label: 'Atvaļinājuma nauda' },
  { value: 'slimibas_lapa', label: 'Slimības lapa (A)' },
  { value: 'stundas', label: 'Samaksa par stundām' },
  { value: 'korekcija', label: 'Korekcija' },
  { value: 'cits', label: 'Cits darbs' },
  { value: 'avanss', label: 'Avanss (atskaitāms)' }
];

export const VSAOI_STATUS_OPTIONS = [
  { value: 'regular', label: 'Parasts darba ņēmējs' },
  { value: 'pension_age', label: 'Sasniegts valsts pensijas vecums' },
  { value: 'service_pension', label: 'Izdienas pensijas saņēmējs / speciālās pensijas saņēmējs' }
];

export const DISABILITY_OPTIONS = [
  { value: 'none', label: 'Nav' },
  { value: '1', label: 'I grupa' },
  { value: '2', label: 'II grupa' },
  { value: '3', label: 'III grupa' }
];

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString('lv-LV') : '-');

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString('lv-LV') : '-');

export const formatAmount = (value, unit) => `${Number(value || 0).toLocaleString('lv-LV', { maximumFractionDigits: 2 })} ${unit || ''}`.trim();

export const formatEur = (value) => `${Number(value || 0).toFixed(2)} €`;

export const mapsUrl = (task) => {
  if (task?.latitude && task?.longitude) {
    return `https://www.google.com/maps/dir/?api=1&destination=${task.latitude},${task.longitude}`;
  }
  const query = task?.property_address || task?.property_name || task?.cadastral_number;
  return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : null;
};
